'use strict'

import './ProductReviewComment.css'
import React from 'react'

/**
 * [ID] => 2890
 * [POST_ID] => 16168
 * [PARENT_ID] => 2888
 * [POST_TEXT] => Отлично! :)
 * [AUTHOR_ID] => 32950
 * [AUTHOR_NAME] =>
 * [AUTHOR_EMAIL] =>
 * [NAME] => Юрий
 * [LAST_NAME] => Тест
 * [AUTHOR_GROUPS_ID] => 3
 * [AUTHOR] => Юрий Тест
 * [DATE_TIME] => 18.07.2022 14:48:11
 *
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
function ProductReviewComment (props) {
  return (
    <div className="answer-text-holder" style={{display: 'block'}}>
      <div className="answer-text-block">
        <div className="testimonial-head">
          <div className="name-block">
            <span className="name">{props.AUTHOR_NAME}</span>,&nbsp;
            <span className="date">{props.DATE_CREATE}</span></div>
        </div>
        <div className="testimonial-text-block ">
          <div className="testimonial-text" dangerouslySetInnerHTML={{__html: props.POST_TEXT}}/>
        </div>
      </div>
    </div>
  )
}

export default ProductReviewComment